(function ($, Drupal, once) {

    //Detect the OS of the devices, and open the tab
    Drupal.behaviors.downloadBlockOpenTabByOS = {
        attach: function (context, settings) {
            once('downloadBlockOpenTabByOS', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    if ($(".download-block-tab").length) {
                        var os = getOS();
                        if (os && $(".product-tab-" + os).length) {
                            $(".product-tab-" + os).tab("show");
                        } else {
                            $(".download-block-tab .nav-item:first-child .product-tab").tab("show");
                        }
                    }
                });
            })
        }
    };

    //display installation instruction popup upon click
    Drupal.behaviors.iosInstallPopup = {
        attach: function (context, settings) {
            once('iosInstallPopup', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    $(".ios-install-popup").click(function (e) {
                        if (isWechatBrowser()) {
                            e.preventDefault();
                            //to display open in browser popup
                            $(".wechat-overlay").addClass("show");
                            return;
                        }
                        if (!isSafariBrowser()) {
                            $(".browser-not-supported").removeClass("d-none").addClass("d-block");
                        }
                        if ($("#iOSInstallCustomAppEnPopup").length > 0) {
                            var myModal = new bootstrap.Modal(document.getElementById('iOSInstallCustomAppEnPopup'), {
                                backdrop: 'static'
                            })
                            myModal.toggle();
                            var carousel = new bootstrap.Carousel("#iosInstallCustomAppEn");
                            carousel.to(0);
                            if ($(this).hasClass("last")) {
                                var last = $("#iosInstallCustomAppEn .carousel-item").length - 1;
                                carousel.to(last);
                            }
                        }
                        if ($("#iOSInstallCustomAppHansPopup").length > 0) {
                            var myModal = new bootstrap.Modal(document.getElementById('iOSInstallCustomAppHansPopup'), {
                                backdrop: 'static'
                            })
                            myModal.toggle();
                            var carousel = new bootstrap.Carousel("#iosInstallCustomAppHans");
                            carousel.to(0);
                            if ($(this).hasClass("last")) {
                                var last = $("#iosInstallCustomAppHans .carousel-item").length - 1;
                                carousel.to(last);
                            }
                        }
                    });
                });
            })
        }
    };

    //custom control inside a bootstrap carousel
    Drupal.behaviors.carouselControl = {
        attach: function (context, settings) {
            once('carouselControl', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    $(".carousel .next").click(function () {
                        var carousel = bootstrap.Carousel.getInstance("#" + $(this).closest(".carousel").attr("id"));
                        carousel.next();
                    });
                });
            })
        }
    };

    //show backup domain QR Code upon click
    Drupal.behaviors.backupDomainPopup = {
        attach: function (context, settings) {
            once('backupDomainPopup', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    $(".backup-domain").click(function (e) {
                        e.preventDefault();
                        if ($("html:lang(en) #backupDomainEnPopup").length > 0) {
                            var myModal = new bootstrap.Modal(document.getElementById('backupDomainEnPopup'), {
                                backdrop: 'static'
                            })
                            myModal.toggle();
                        }
                        if ($("html:lang(zh-hans) #backupDomainHansPopup").length > 0) {
                            var myModal = new bootstrap.Modal(document.getElementById('backupDomainHansPopup'), {
                                backdrop: 'static'
                            })
                            myModal.toggle();
                        }
                    });
                });
            })
        }
    };

    //Enable popover
    Drupal.behaviors.popover = {
        attach: function (context, settings) {
            once('popover', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    if (!isMobile()) {
                        //Drupal.t doesnt work somehow, this is a workaround
                        let title = drupalSettings.path.currentLanguage == "zh-hans" ? "请用手机相机或浏览器扫码" : Drupal.t('Use camera or browser to scan');
                        let androidApp = drupalSettings.path.currentLanguage == "zh-hans" ? "安卓App" : Drupal.t('Android App');
                        //for ios qrcode
                        if ($(".ios-qrcode").length > 0) {
                            $('.ios-dl-url.popover-qrcode').popover({
                                trigger: 'hover',
                                html: true,
                                content: function () {
                                    return '<img class="img-fluid" src="' + $('.ios-qrcode').attr("src") + '" /><p class="text-center">iOS App</p>';
                                },
                                title: title,
                                placement: 'top'
                            })
                        }
                        //for android qrcode
                        if ($(".android-qrcode").length > 0) {
                            $('.android-dl-url.popover-qrcode').popover({
                                trigger: 'hover',
                                html: true,
                                content: function () {
                                    return '<img class="img-fluid" src="' + $('.android-qrcode').attr("src") + '" /><p class="text-center">' + androidApp + '</p>';
                                },
                                title: title,
                                placement: 'top'
                            })
                        }
                    }
                });
            })
        }
    };

    //add icon to class name
    Drupal.behaviors.addIcon = {
        attach: function (context, settings) {
            once('addIcon', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    $(".add-icon-appstore").prepend("<i class='fab fa-app-store me-1' />");
                    $(".add-icon-ios").prepend("<i class='fab fa-apple me-1' />");
                    $(".add-icon-android").prepend("<i class='fab fa-android me-1' />");
                    $(".add-icon-windows").prepend("<i class='fab fa-windows me-1' />");
                    $(".add-icon-macos").prepend("<i class='fab fa-app-store me-1' />");
                    $(".add-icon-tv").prepend("<i class='fas fa-tv me-1' />");
                    $(".add-icon-link").prepend("<i class='fas fa-link me-1' />");
                    $(".add-icon-user").prepend("<i class='fas fa-user me-1' />");
                    $(".add-icon-download").prepend("<i class='fas fa-download me-1' />");
                    $(".add-icon-qrcode").prepend("<i class='fas fa-qrcode me-1' />");

                });
            })
        }
    };

    //open accordion by url
    Drupal.behaviors.accordionUrl = {
        attach: function (context, settings) {
            once('accordionUrl', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    if (window.location.hash) {
                        var hash = window.location.hash;
                        $(hash).collapse('show');
                        $('html, body').animate({
                            scrollTop: $(hash).offset().top - 70
                        });
                    }
                });
            })
        }
    };

    //click to copy the data
    Drupal.behaviors.clickToCopy = {
        attach: function (context, settings) {
            once('clickToCopy', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    var d = new ClipboardJS('.click-to-copy', {
                        text: function (a) {
                            // AS-1956
                            const urlStr = a.getAttribute('data-clipboard');
                            try {
                                const url = new URL(urlStr);
                                const host = url.host;

                                return urlStr.replace(host, window.location.host);
                            } catch (err) {
                                return urlStr;
                            }
                        }
                    });
                    d.on('success', function (a) {
                        var b = bootstrap.Tooltip.getInstance(a.trigger);
                        a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title-copied"));
                        b ? b.show() : null;
                        a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title"));
                        a.clearSelection()
                    });
                });
            })
        }
    };


    //enable bootstrap tooltip
    Drupal.behaviors.bsTooltip = {
        attach: function (context, settings) {
            once('bsTooltip', '[data-bs-toggle="tooltip"]', context).forEach(function (element) {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                })
            })
        }
    };

    //show baidu popup if browser is baidu
    Drupal.behaviors.baiduBrowserPopup = {
        attach: function (context, settings) {
            once('baiduBrowserPopup', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    $(".ios-up-redirect").click(function (e) {
                        if (isBaiduBrowser()) {
                            if ($("html:lang(en) #baiduBrowserIOSEnPopup").length > 0) {
                                e.preventDefault();
                                var myModal = new bootstrap.Modal(document.getElementById('baiduBrowserIOSEnPopup'), {
                                    backdrop: 'static'
                                })
                                myModal.toggle();
                                $("html:lang(en) #baiduBrowserIOSEnPopup .next-link").attr("href", $(this).attr("href"));
                            }
                            if ($("html:lang(zh-hans) #baiduBrowserIOSHansPopup").length > 0) {
                                e.preventDefault();
                                var myModal = new bootstrap.Modal(document.getElementById('baiduBrowserIOSHansPopup'), {
                                    backdrop: 'static'
                                })
                                myModal.toggle();
                                $("html:lang(zh-hans) #baiduBrowserIOSHansPopup .next-link").attr("href", $(this).attr("href"));
                            }
                        }
                    });

                    $(".android-dl-url").click(function (e) {
                        if (isBaiduBrowser()) {
                            if ($("html:lang(en) #baiduBrowserAndroidEnPopup").length > 0) {
                                e.preventDefault();
                                var myModal = new bootstrap.Modal(document.getElementById('baiduBrowserAndroidEnPopup'), {
                                    backdrop: 'static'
                                })
                                myModal.toggle();
                                $("#baiduBrowserAndroidEnPopup .next-link").attr("href", $(this).attr("href"));
                                $("#baiduBrowserAndroidEnPopup .copy-url").attr("data-clipboard", $(location).attr("href"));
                                var d = new ClipboardJS('#baiduBrowserAndroidEnPopup .copy-url', {
                                    text: function (a) {
                                        return a.getAttribute('data-clipboard')
                                    },
                                    container: document.getElementById('baiduBrowserAndroidEnPopup')
                                });
                                d.on('success', function (a) {
                                    var b = bootstrap.Tooltip.getInstance(a.trigger);
                                    a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title-copied"));
                                    b.show();
                                    a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title"));
                                    a.clearSelection()
                                });
                            }
                            if ($("html:lang(zh-hans) #baiduBrowserAndroidHansPopup").length > 0) {
                                e.preventDefault();
                                var myModal = new bootstrap.Modal(document.getElementById('baiduBrowserAndroidHansPopup'), {
                                    backdrop: 'static'
                                })
                                myModal.toggle();
                                $("#baiduBrowserAndroidHansPopup .next-link").attr("href", $(this).attr("href"));
                                $("#baiduBrowserAndroidHansPopup .copy-url").attr("data-clipboard", $(location).attr("href"));
                                var d = new ClipboardJS('#baiduBrowserAndroidHansPopup .copy-url', {
                                    text: function (a) {
                                        return a.getAttribute('data-clipboard')
                                    },
                                    container: document.getElementById('baiduBrowserAndroidHansPopup')
                                });
                                d.on('success', function (a) {
                                    var b = bootstrap.Tooltip.getInstance(a.trigger);
                                    a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title-copied"));
                                    b.show();
                                    a.trigger.setAttribute('data-bs-original-title', a.trigger.getAttribute("data-title"));
                                    a.clearSelection()
                                });
                            }
                        }
                    });
                });
            })
        }
    };

    //misc js
    $(document).ready(function () {

        // show modal on page load
        $(".modal.onpageload").each(function (index) {
            if (!$(this).attr("id")) return;
            var myModal = new bootstrap.Modal(document.getElementById($(this).attr("id")), {
                backdrop: 'static'
            })
            myModal.toggle();
        });

    });


})(jQuery, Drupal, once);


/*** Helper Functions Start Here ***/

function isMobile() {
    let OSName = getOS();
    return (OSName == "android" || OSName == "ios");
}

function getOS() {
    var OSName = false;
    if (navigator.userAgent.indexOf("Win") != -1) OSName = "windows";
    if (navigator.userAgent.indexOf("Mac") != -1) OSName = "macos";
    if (navigator.userAgent.indexOf("Linux") != -1) OSName = "linux";
    if (navigator.userAgent.indexOf("Android") != -1) OSName = "android";

    //this is to fix the safari on ipad is shown as macos issue
    // if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "ios";
    if (iOS()) {
        OSName = 'ios';
    }
    return OSName;
}

function iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function isWechatBrowser() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') > 0;
}


function isBaiduBrowser() {
    return navigator.userAgent.toLowerCase().indexOf('baidu') > 0;
}

//Mobile chrome, firefox has Safari in UA
function isSafariBrowser() {
    return (navigator.userAgent.indexOf("Safari") > -1);
}

function fallbackGetUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

function getUrlParameter(sParam) {
    if ('URLSearchParams' in window) {
        // Browser supports URLSearchParams
        let searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(sParam);
    } else {
        return fallbackGetUrlParameter(sParam);
    }
}

function updateUrlParameter(key, value) {
    if ('URLSearchParams' in window) {
        // Browser supports URLSearchParams
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set(key, value);
        const newUrl = `${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
        window.history.replaceState({}, '', newUrl);
    }
}

function deleteUrlParameter(key) {
    if ('URLSearchParams' in window) {
        // Browser supports URLSearchParams
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(key);
        const newUrl = `${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
        window.history.replaceState({}, '', newUrl);
    }
}

function isFromSearchEngine() {
    if ((document.referrer.indexOf('google.') !== -1) ||
        (document.referrer.indexOf('bing.') !== -1) ||
        (document.referrer.indexOf('baidu.') !== -1) ||
        (document.referrer.indexOf('quark.') !== -1) ||
        (document.referrer.indexOf('yahoo.') !== -1) ||
        (document.referrer.indexOf('haosou.') !== -1) ||
        (document.referrer.indexOf('yandex.') !== -1) ||
        (document.referrer.indexOf('ecosia.') !== -1) ||
        (document.referrer.indexOf('sogou.') !== -1) ||
        (document.referrer.indexOf('so.') !== -1)) {
        return true;
    }
    return false;
}

function getSearchEngine() {
    if (document.referrer.indexOf('google.') !== -1) {
        return 'google';
    } else if (document.referrer.indexOf('bing.') !== -1) {
        return 'bing';
    } else if (document.referrer.indexOf('baidu.') !== -1) {
        return 'baidu';
    } else if (document.referrer.indexOf('quark.') !== -1) {
        return 'quark';
    } else if (document.referrer.indexOf('yahoo.') !== -1) {
        return 'yahoo';
    } else if (document.referrer.indexOf('haosou.') !== -1) {
        return 'haosou';
    } else if (document.referrer.indexOf('yandex.') !== -1) {
        return 'yandex';
    } else if (document.referrer.indexOf('ecosia.') !== -1) {
        return 'ecosia';
    } else if (document.referrer.indexOf('sogou.') !== -1) {
        return 'sogou';
    } else if (document.referrer.indexOf('so.') !== -1) {
        return 'so'; // 360 Search
    }
    return false
}

function removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

// get source from url
function getSourceFromURL() {
    let encodedURLSource = getUrlParameter('source') ?? '';
    return decodeURIComponent(encodedURLSource);
}


// handle raf code
function handleRafCode(params) {
    let rafCode = getUrlParameter('u');
    if (rafCode != null) {
        params.set("u", rafCode);
        return true;
    }
    return false;
}

// handle channel code
function handleChannelCode(params) {
    // channel code
    let channelCode = getUrlParameter('channel');
    //update channel url and set to text
    if (channelCode != null) {
        params.set("channel", channelCode);
    }
}

// handle source code
function handleSourceCode(params, cookies = "") {
    let sources = [];
    
    // get source from Search Engine
    if (isFromSearchEngine() && getSearchEngine()) {
        sources.push(getSearchEngine());
    }

    // get source from url
    let decodedURLSource = getSourceFromURL();
    if (decodedURLSource.length > 0) {
        sources = sources.concat(decodedURLSource.split("|"));
    }

    if (cookies.length === 0 || cookies.get("clipboard") != "copied") {
        getSourceFromMetatag() ? sources.push(getSourceFromMetatag()) : null;
        getVersionFromMetatag() ? sources.push(getVersionFromMetatag()) : null;

    }

    // update source url and set to text
    if (sources.length > 0) {
        // update source url
        updateUrlParameter("source", removeDuplicates(sources).join("|"));
        params.set("source", removeDuplicates(sources).join("|"));
    }
}

// handle click id
function handleClickID(params) {
    // click id
    let clickId = getUrlParameter('clickid');
    // update click id url and set to text
    if (clickId != null) {
        params.set("clickId", clickId);
    }
}

// get source
function getSourceFromMetatag() {
    var metaTag = jQuery('meta[name="custom_source"]');
    if (metaTag.length) {
        return metaTag.attr('content');
    }
    return false;
}

// get version
function getVersionFromMetatag() {
    var metaTag = jQuery('meta[name="custom_version"]');
    if (metaTag.length) {
        return metaTag.attr('content');
    }
    return false;
}
